import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import type { RootState } from "../store/store";
import { LOGINPAGE } from "../views/auth/routes";
import { isCampanhasUserFromToken } from "../utils/authToken";
import { isTokenValid } from "../utils/isTokenValid";
import { staffHomeFromToken } from "../utils/staffHome";

/**
 * Rotas do criador de campanhas: `ADMIN` ou `GESTOR_CAMPANHAS` (principal ou
 * adicional). Mesmo desenho do `DpRoute`: sem token, login; com outro papel, a
 * home daquele papel. O módulo retirado do administrador restrito quem barra é o
 * `StaffLayout`.
 */
const CampanhasRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  const token = useSelector((s: RootState) => (s as any).auth?.accessToken);

  if (!rehydrated) return null;
  if (!isTokenValid(token)) return <Navigate to={LOGINPAGE()} replace />;
  if (!isCampanhasUserFromToken(token)) return <Navigate to={staffHomeFromToken(token)} replace />;
  return children;
};

export default CampanhasRoute;
